import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')
const PagamentoAssociarEtapas = () => import('./PagamentoAssociarEtapas.vue')
const PagamentoAssociarDespesas = () => import('./PagamentoAssociarDespesas.vue')

export default {
    path: 'pagamentos',
    name: 'Sgtec_Fornecedor_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-FORN-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'Sgtec_Fornecedor_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('SGTEC-FORN-PAG-02')) {
                    next()
                }
            },
            children: [
                {
                    path: 'associaretapas',
                    name: 'Sgtec_Fornecedor_Pagamentos_AssociarEtapas',
                    component: PagamentoAssociarEtapas,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('SGTEC-FORN-PAG-03')) {
                            next()
                        }
                    }
                },
                {
                    path: 'associardespesas',
                    name: 'Sgtec_Fornecedor_Pagamentos_AssociarDespesas',
                    component: PagamentoAssociarDespesas,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('SGTEC-FORN-PAG-03')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
